import { render, staticRenderFns } from "./coachesList.vue?vue&type=template&id=37b9c8f9&scoped=true"
import script from "./coachesList.vue?vue&type=script&lang=js"
export * from "./coachesList.vue?vue&type=script&lang=js"
import style0 from "./coachesList.vue?vue&type=style&index=0&id=37b9c8f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b9c8f9",
  null
  
)

export default component.exports